export default {
	title: 'Organización de Inspección',
	actions: {
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Operación exitosa',
		selectDeleteWarning: 'Por favor seleccione los registros a eliminar',
		operateSuccess: 'Operación exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	table: {
		id: 'ID',
		name: 'Nombre',
		location: 'Ubicación',
		icon: 'Icono'
	},
	buttons: {
		expandAll: 'Expandir Todo',
		collapseAll: 'Colapsar Todo',
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar'
	},
	dialog: {
		add: 'Añadir',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	widgetForm: {
		superiorDepartment: 'Departamento Superior',
		name: 'Nombre',
		location: 'Ubicación',
		icon: 'Icono',
		leader: 'Líder',
		sort: 'Ordenar',
		logoPicture: 'Imagen del Logo',
		aiAssistantEnabled: 'Asistente IA Activado',
		gridLayout: 'Diseño de Cuadrícula',
		sensorStatusChangeNotify: 'Notificación de Cambio de Estado del Punto de Medición',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		placeholder: {
			superiorDepartment: 'Por favor seleccione el departamento superior',
			name: 'Por favor ingrese el nombre',
			location: 'Por favor ingrese la ubicación',
			icon: 'Por favor seleccione el icono',
			leader: 'Por favor seleccione el líder',
			sort: 'Por favor ingrese el orden',
			aiAssistantEnabled: 'Por favor seleccione si desea activar',
			sensorStatusChangeNotify: 'Notificación de Cambio de Estado del Punto de Medición'
		},
		options: {
			aiAssistantStatus: {
				closed: 'Cerrado',
				enabled: 'Activado'
			},
			notifyStatus: {
				offline: 'Notificación Fuera de Línea',
				abnormal: 'Notificación de Anomalía',
				all: 'Notificar Todo',
				none: 'No Notificar Nada'
			}
		}
	}
}
